<template>
  <modal size="medium"
         v-show="show"
         id="ModalFixingQuantity">

    <template v-slot:header>
      <h3 class="title">Fixação</h3>
    </template>

    <template v-slot:body>
      <div class="container">
        <div class="form-row">
          <div class="col-4 form-group col-md-4">
            <label for="fixingEditPrice">Preço</label>
            <input type="text"
                   id="fixingEditPrice"
                   :class="{'is-invalid': errors.price}"
                   autocomplete="off"
                   v-money="{precision: 2, decimal: ',', thousands: '.'}"
                   class="form-control form-control-sm t-r"
                   v-model="entity.price"/>
            <field-messages :errors="errors.price"/>
          </div>
          <div class="col-4 form-group col-md-4">
            <label for="fixingEditQuantity">Quantidade</label>
            <input type="text"
                   id="fixingEditQuantity"
                   :class="{'is-invalid': errors.quantity}"
                   autocomplete="off"
                   v-money="{precision: 3, decimal: ',', thousands: '.'}"
                   class="form-control form-control-sm t-r"
                   v-model="entity.quantity"/>
            <field-messages :errors="errors.quantity"/>
          </div>
          <div class="col-4 form-group col-md-4">
            <label for="fixingEditDate">Data</label>
            <div class="input-group input-group-sm">
              <input type="text"
                     id="fixingEditDate"
                     required
                     v-model="entity.fixing_at"
                     placeholder="DD/MM/AAAA"
                     :class="{'is-invalid': errors.fixing_at}"
                     v-flatpickr
                     v-mask="'##/##/####'"
                     class="form-control form-control-sm t-c plch-center n-m-r-right">
              <div class="input-group-append">
                <div class="input-group-text">
                  <svg-icon icon="calendar-alt"/>
                </div>
              </div>
            </div>
            <field-messages :errors="errors.fixing_at"/>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12">
            <label for="fixingEditNotes">Obsevações</label>
            <textarea id="fixingEditNotes"
                      v-model="entity.notes"
                      maxlength="4000"
                      class="form-control form-control-sm"></textarea>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <button type="button"
              @click="is_show = false"
              class="btn btn-sm btn-dark">
        <svg-icon icon="times"/>
        Fechar
      </button>
      <button type="button"
              @click="save"
              class="btn btn-sm btn-theme-1">
        <svg-icon :icon="!!entity && !!entity.id ? 'save' : 'plus'"/>
        {{!!entity && !!entity.id ? 'Alterar' : 'Adicionar'}}
      </button>
    </template>
  </modal>
</template>

<script>
import Big from 'big.js'
import {isEmpty} from "@/utils/Utils";
import dayjs from "dayjs";
import Vue from "vue";
const EVENT_SHOW = 'FixingQuantityEventBus.SHOW'

const FixingQuantityEventBus = new Vue();

const show = (entity) => {
  FixingQuantityEventBus.$emit(EVENT_SHOW, {...Object.assign({}, entity === null ? {} : entity)});
};

const mold = {
  fixing_at: '',
  price: '',
  quantity: '',
  notes: '',
}

export {
  show
};

export default {
  name: "ModalFixingQuantity",
  data() {
    return {
      is_show: false,
      entity: {
        ...mold
      },
      errors: {}
    }
  },
  mounted() {
    FixingQuantityEventBus.$on(EVENT_SHOW,entity => {
      if (!!this.entity) this.entity = {...entity}
      else this.entity = {...mold}

      this.is_show = true
    })
  },
  methods: {
    save() {
      if (this.isValid()) {
        this.$emit('onSave', {
          ...this.entity,
          fixing_at: dayjs(this.entity.fixing_at, 'DD/MM/YYYY').toDate(),
          price: this.price,
          quantity: this.quantity,
        })
        this.entity = {...mold}
      }
    },
    isValid() {
      this.errors = {}
      if (this.quantity <= 0) this.errors.quantity = ["Campo obrigatório"]
      if (this.price <= 0) this.errors.price = ["Campo obrigatório"]
      if (isEmpty(this.entity.fixing_at)) this.errors.fixing_at = ["Campo obrigatório"]

      return Object.keys(this.errors).length === 0
    }
  },
  computed: {
    show() {
      return this.is_show
    },
    quantity() {
      return parseFloat(new Big(this.entity.quantity.replaceAll('.', '').replaceAll(',', '.')).toString())
    },
    price() {
      return parseFloat(new Big(this.entity.price.replaceAll('.', '').replaceAll(',', '.')).toString())
    }
  }
}
</script>
